import { Description, Inner, ImageWrapper, Title, Screen } from "./403.styles";
import { useTranslation } from "react-i18next";
import Lottie from "react-lottie";
import lockAnimation from "./lockAnimation";
import { useStore } from "../../store/store";
import { useEffect } from "react";

export default function AccessDeniedPage() {
  const { t } = useTranslation();
  const setActiveMenuId = useStore.useSetActiveMenuId();

  useEffect(() => {
    setActiveMenuId(undefined);
  }, []);

  return (
    <Screen>
      <Inner>
        <ImageWrapper>
          <Title>{t("403Page.title")}</Title>

          <Lottie
            speed={0.3}
            width={200}
            height={200}
            options={{
              loop: true,
              animationData: lockAnimation,
              rendererSettings: {
                preserveAspectRatio: "xMidYMid slice",
                clearCanvas: true,
              },
            }}
          />
        </ImageWrapper>
        <Description>{t("403Page.description")}</Description>
      </Inner>
    </Screen>
  );
}
